import { keycloakService } from "@Services/keycloak";

class TokenAutoRefreshService {
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private readonly CHECK_INTERVAL = 60 * 1000; // 1 minute

  start(): void {
    this.stop();
    this.intervalId = setInterval(async () => {
      if (!keycloakService.isTokenValid()) {
        try {
          await keycloakService.ensureValidToken();
        } catch (error) {
          console.error("Auto token refresh failed:", error);
        }
      }
    }, this.CHECK_INTERVAL);
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

export const tokenAutoRefreshService = new TokenAutoRefreshService();
